export default "__VITE_ASSET__0960dbfd__"